"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var theme_1 = __importDefault(require("../../theme"));
var styles_1 = require("./styles");
var NUM_OF_DOTS = 3;
/**
 * Renders an animated three dots loader.
 * @param color Optional string param that gives the fill color of the loader.
 */
function Loader(_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.default.colorsPalette.white.default : _b;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.MainContainer, null, __spreadArrays(Array(NUM_OF_DOTS)).map(function (_, i) { return (react_1.default.createElement(styles_1.Dot, { key: i, delay: "0." + i + "s", backgroundColor: color })); }))));
}
exports.default = Loader;
//# sourceMappingURL=index.js.map